<!--  -->
<template>
  <div class="myPopup">
    <van-popup v-model="isShowPopup">
      <div class="myPopupContent">
        <div class="myPopupContentHeader">
          <van-icon
            @click="clickClose"
            name="cross"
          />
        </div>
        <div class="myPopupContentCenter">
          <PDF
            @isLoadDone="isLoadDone"
            :urlLink="url"
          ></PDF>
        </div>
        <van-button
          class="vanButton handeCopy"
          :aria-label="copyText"
          @click="handeCopy"
          color="#FF6538"
          type="primary"
        >复制下载链接</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast } from 'vant';
import PDF from './PDF/index.vue';

export default {
  name: 'myPopupContract',
  components: {
    PDF,
  },
  props: ['value', 'contractId', 'ossKey'],
  data() {
    return {
      isShowPopup: false,
      copyText: '',
      toast: null,
      count: 1,
    };
  },
  computed: {
    url() {
      return `${window.location.origin}/backloansuper/loan/supermarket/previewContract/v1.0?conId=${this.contractId}`;
    },
  },
  methods: {
    clickClose() {
      this.isShowPopup = false;
    },
    handeCopy() {
      // this.$toast.loading({
      //   message: '复制中...',
      //   clear: true,
      //   duration: 0,
      //   forbidClick: true,
      //   loadingType: 'spinner',
      // });
      const flag = this.getHandeCopy();
      if (flag) {
        const clipboard = new Clipboard('.handeCopy', {
          text(trigger) {
            console.log(trigger);
            return trigger.getAttribute('aria-label');
          },
        });
        clipboard.on('success', () => {
          Toast('复制成功');
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on('error', () => {
          // 不支持复制 console.log('该浏览器不支持自动复制')
          // 释放内存
          clipboard.destroy();
        });
      };
    },
    // eslint-disable-next-line consistent-return
    async getHandeCopy() {
      const res = await this.$api.PublicPage.getDownloadContractUrl({
        conId: this.contractId,
        ossKey: this.ossKey,
      });
      if (res.success) {
        // eslint-disable-next-line no-plusplus
        this.copyText = res.data;
        return true;
      };
      this.$toast.fail({
        message: res.returnMessage,
        forbidClick: true,
        duration: 2500,
      });
    },
    isLoadDone() {
      this.getHandeCopy();
    },
  },
  watch: {
    isShowPopup: {
      handler() {
        this.$emit('input', this.isShowPopup);
      },
    },
    value: {
      handler(val) {
        this.isShowPopup = !!val;
      },
    },
  },
};
</script>
<style scoped>
.myPopupContent {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.myPopup >>> .van-popup--center {
  border-radius: 8px;
  width: 85%;
  height: 85%;
}
.myPopupContentHeader {
  width: 100%;
  background: #fff;
  height: 50px;
  border-bottom: 1px solid #e9f0f5;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  font-size: 12;
  color: #687282;
  margin-right: 20px;
}
.myPopupContentCenter {
  flex: 1;
  overflow: auto;
}
.vanButton {
  width: 91%;
  height: 44px;
  margin: 16px;
}
</style>
